import { FiStar, FiHeart, FiThumbsUp } from 'react-icons/fi';

export const RATING_ICONS = {
    star: {
        label: 'Звезда',
        Icon: FiStar
    },
    heart: {
        label: 'Сердце',
        Icon: FiHeart
    },
    thumb_up: {
        label: 'Лайк',
        Icon: FiThumbsUp
    },
};
